// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Flex:opsz,wght@8..144,100;8..144,200;8..144,300;8..144,400;8..144,500;8..144,600;8..144,700;8..144,800;8..144,900;8..144,1000&display=swap);"]);
// Module
exports.push([module.id, "body{font-family:\"Roboto Flex\",sans-serif;font-weight:400;font-size:1em}*:focus{outline:none}.BeaconFabButtonFrame{bottom:50px !important}", ""]);
// Exports
module.exports = exports;
